<div mat-dialog-title>Order Selection
  <div class="dialog-close-button">
    <a (click)="onClose()" id="close">
      <img src="/assets/images/close-popup.png">
    </a>
  </div>
</div>
<form (ngSubmit)="onOrderSubmit()">
  <div mat-dialog-content cdkFocusInitial>
    <div *ngIf="isMobileDevice(); then addToCartMobile else addToCartDesktop">
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button type="submit" id="btn-ok">OK</button>
    <button mat-raised-button [mat-dialog-close]="false" id="btn-cancel">Cancel</button>
  </div>
</form>

<ng-template #addToCartMobile>
  <div class="order-selection-table-responsive table result-container">
    <mat-table #table [dataSource]="ordersList">
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let order; let i = index">
          <mat-radio-button (change)="onOrderSelect(order)" class="add-cart-order-select" id="{{i+1}}-1"></mat-radio-button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="orderNo">
        <mat-header-cell *matHeaderCellDef> Order Number </mat-header-cell>
        <mat-cell *matCellDef="let order; let i = index" id="{{i+1}}-2"> {{order.orderNum}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="createdDate">
        <mat-header-cell *matHeaderCellDef> Created Date </mat-header-cell>
        <mat-cell *matCellDef="let order; let i = index" id="{{i+1}}-3"> {{order.createdDate}}
          <span *ngIf="order.createdDate">EST</span>
        </mat-cell>
      </ng-container>
      <mat-header-row class="rowHeaderColor" *matHeaderRowDef="orderColumnsMobile"></mat-header-row>
      <mat-row *matRowDef="let row; columns: orderColumnsMobile; let i = index" id="{{i+1}}"></mat-row>
    </mat-table>
  </div>
  <mat-error *ngIf="!orderSelected">Please select an order to continue.</mat-error>
</ng-template>

<ng-template #addToCartDesktop>
  <div class="order-selection-table-responsive table result-container">
    <mat-table #table [dataSource]="ordersList">
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let order; let i = index">
          <mat-radio-button (change)="onOrderSelect(order)" class="add-cart-order-select" id="{{i+1}}-1"></mat-radio-button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="orderNo">
        <mat-header-cell *matHeaderCellDef> Order Number </mat-header-cell>
        <mat-cell *matCellDef="let order; let i = index" id="{{i+1}}-2"> {{order.orderNum}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="poNumber">
        <mat-header-cell *matHeaderCellDef> PO Number </mat-header-cell>
        <mat-cell *matCellDef="let order; let i = index"> {{order.poNum}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="createdDate">
        <mat-header-cell *matHeaderCellDef> Created Date </mat-header-cell>
        <mat-cell *matCellDef="let order; let i = index" id="{{i+1}}-3"> {{order.createdDate}}
          <span *ngIf="order.createdDate">EST</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="createdBy">
        <mat-header-cell *matHeaderCellDef> Created By </mat-header-cell>
        <mat-cell *matCellDef="let order; let i = index" id="{{i+1}}-4"> {{order.createdBy.toString()}} </mat-cell>
      </ng-container>
      <mat-header-row class="rowHeaderColor" *matHeaderRowDef="orderColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: orderColumns; let i = index" id="{{i+1}}"></mat-row>
    </mat-table>
  </div>
  <mat-error *ngIf="!orderSelected">Please select an order to continue.</mat-error>
  <p class="cartText">Notes:</p>
  <ol>
    <li>This option can be changed under My Account -> Web Account Settings.</li>
    <li>Open orders will be deleted after 7 days.</li>
  </ol>
</ng-template>